module.exports = __webpack_public_path__ + "assets/logo_admin_panel.4f84c104.svg";